const DEFAULT_LOCALE = 'zh-CN'
const LOCALES = ['zh-CN']
const DEFAULT_NAMESPACE = 'components'
const LOCALE_PATH = './public/locales'
const LOCALE_STRUCTURE = '{{lng}}/{{ns}}'
const LOCALE_EXTENSION = 'json'

export const defaultConfig = {
  defaultNS: DEFAULT_NAMESPACE,
  errorStackTraceLimit: 0,
  i18n: {
    defaultLocale: DEFAULT_LOCALE,
    locales: LOCALES,
  },
  get initImmediate(): boolean {
    return typeof window !== 'undefined'
  },
  interpolation: {
    escapeValue: false,
  },
  load: 'currentOnly',
  localeExtension: LOCALE_EXTENSION,
  localePath: LOCALE_PATH,
  localeStructure: LOCALE_STRUCTURE,
  react: {
    useSuspense: false,
  },
  reloadOnPrerender: false,
  serializeConfig: true,
  use: [],
}
